import { FC } from 'react';

interface Props {
    image: string;
}

const MediaGalleryComponent: FC<Props> = ({ image }) => {
    return (
        <div className="grid__item product__media-wrapper">
            <div className="product-media-container media-type-image media-fit-contain global-media-settings gradient constrain-height -clothing-product">
                <div className="product__media media media--transparent br-productImage_media">
                    <img src={image} />
                </div>
            </div>
        </div>
    );
};

export default MediaGalleryComponent;
